var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.425 9.12a1.5 1.5 0 00-1.295-1.03l-5.567-.48-2.183-5.19a1.495 1.495 0 00-2.76 0L8.444 7.61l-5.574.482a1.5 1.5 0 00-.854 2.631l4.229 3.696-1.268 5.488a1.5 1.5 0 002.235 1.625l4.781-2.906 4.792 2.906a1.5 1.5 0 002.235-1.625l-1.267-5.494 4.229-3.69a1.5 1.5 0 00.443-1.602zm-1.427.47l-4.228 3.69a1.5 1.5 0 00-.476 1.473l1.27 5.497-4.788-2.906a1.491 1.491 0 00-1.55 0L6.444 20.25l1.262-5.494a1.5 1.5 0 00-.476-1.473L3 9.595v-.008l5.573-.482a1.5 1.5 0 001.251-.914L12 3.007l2.175 5.184a1.5 1.5 0 001.252.914L21 9.587v.006l-.002-.003z"
  })));
}
export default SvgFavouriteRegular;